module.exports = __webpack_public_path__ + "img/default-btn-ar.207cee30.png";